const SipHome = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/SipHome')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'sipconfig',
    component: SipHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'SipConfig',
  },
]
